import { Component, computed, input } from '@angular/core';
import { CountryGroup } from '../../enums/country-group';
import { CommonHelper } from '../../helpers/common.helper';
import type { AllowedCountries } from '../../interfaces/common/allowed-countries';
import { StringCellComponent } from '../cells/string-cell/string-cell.component';
import { DictionaryCode } from './../../enums/dictionary-code';

@Component({
  selector: 'app-allowed-countries',
  imports: [StringCellComponent],
  templateUrl: './allowed-countries.component.html',
  styleUrl: './allowed-countries.component.scss',
})
export class AllowedCountriesComponent {
  public readonly allowedCountries = input.required<AllowedCountries>();

  protected readonly DictionaryCode = DictionaryCode;

  protected whitelist = computed(() => {
    const { whitelist, group } = this.allowedCountries();

    if (group === CountryGroup.NATIONAL) {
      return `${DictionaryCode.COUNTRY}.${whitelist[0]}`;
    }
    if (group) return `${DictionaryCode.COUNTRIES_GROUP}.${group}`;

    return CommonHelper.getGroupedCountriesKeys(whitelist);
  });
}
